<template>
  <div>
    <h2 class="subtitle">Options du site internet</h2>
    <hr />
    <agence_detail></agence_detail>
  </div>
</template>

<script>
import Agence_detail from "./Agence_detail";
export default {
  name: "WebsiteAbout",
  components: { Agence_detail }
};
</script>
